export default __webpack_public_path__ + "static/media/ali.3d1ab3ab.svg";